<script>
import { globalState } from '@/stores/global';
import DefaultAvatar from '@/assets/icons/DefaultAvatar.vue';

export default {
	components: { DefaultAvatar },
	props: ['follower'],
	emits: ['handleToggleFollowAction'],
	setup() {
		return {
			loggedInUser: globalState.user
		};
	}
};
</script>
<template>
	<div class="flex items-center p-4 space-x-4 border-t flex-col lg:flex-row">
		<div class="flex flex-row justify-between w-full lg:w-1/12 lg:mr-3 items-center">
			<div class="flex flex-row items-center">
				<router-link :to="{ name: 'my_page', params: { userId: follower.user_id } }">
					<div class="w-16 h-16 cursor-pointer mr-4 lg:mr-0">
						<img v-if="follower.user?.icon_img" :src="follower.user?.icon_img" class="object-cover w-full h-full rounded-full" />
						<default-avatar v-if="!follower.user?.icon_img" />
					</div>
				</router-link>
				<div class="lg:hidden">
					<div class="text-base lg:text-xl font-bold">{{ follower.user?.nickname }}</div>
				</div>
			</div>
			<div class="lg:hidden">
				<button
					class="text-base font-semibold text-white bg-center bg-no-repeat bg-contain lg:h-19 h-50px w-140px bg-button-blue lg:w-44 hover:bg-button-yellow focus:outline-none hover:text-blue-400"
					@click="
						$emit('handleToggleFollowAction', {
							user_id: loggedInUser.id,
							follow_user_id: follower.user_id
						})
					"
				>
					{{ follower.loginUserFollowDocId ? 'フォロー中' : 'フォローする' }}
				</button>
			</div>
		</div>
		<div class="w-full lg:w-8/12">
			<div class="text-base lg:text-xl font-bold hidden lg:block">{{ follower.user?.nickname }}</div>
			<div class="mt-1 font-medium text-xs lg:text-base">
				{{ follower.user?.greeting?.substring(0, 50) }}
				<span v-if="follower.user?.greeting?.length > 50">...</span>
			</div>
		</div>
		<div class="w-2/5 lg:w-3/12 hidden lg:block">
			<div class="text-right">
				<button
					class="text-base font-semibold text-white bg-center bg-no-repeat bg-contain lg:h-19 h-50px w-140px bg-button-blue lg:w-44 hover:bg-button-yellow focus:outline-none hover:text-blue-400"
					@click="
						$emit('handleToggleFollowAction', {
							user_id: loggedInUser.id,
							follow_user_id: follower.user_id
						})
					"
				>
					{{ follower.loginUserFollowDocId ? 'フォロー中' : 'フォローする' }}
				</button>
			</div>
		</div>
		<!-- <div class="w-1/5 lg:w-1/12">
			<router-link :to="{ name: 'my_page', params: { userId: follower.user_id } }">
				<div class="w-16 h-16 cursor-pointer">
					<img
						v-if="follower.user?.icon_img"
						:src="follower.user?.icon_img"
						class="object-cover w-full h-full rounded-full"
					/>
					<default-avatar v-if="!follower.user?.icon_img" />
				</div>
			</router-link>
		</div>
		<div class="w-2/5 lg:w-8/12">
			<div class="text-base font-bold">{{ follower.user?.nickname }}</div>
			<div class="mt-1 font-medium">
				{{ follower.user?.greeting?.substring(0, 50) }}
				<span v-if="follower.user?.greeting?.length > 50">...</span>
			</div>
		</div>
		<div class="w-2/12 lg:w-3/12">
			<div class="text-right">
				<button
					class="text-base font-semibold text-white bg-center bg-no-repeat bg-contain lg:h-19 h-50px w-140px bg-button-blue lg:w-44 hover:bg-button-yellow focus:outline-none hover:text-blue-400"
					@click="
						$emit('handleToggleFollowAction', {
							user_id: loggedInUser.id,
							follow_user_id: follower.user_id
						})
					"
				>
					{{ follower.loginUserFollowDocId ? 'フォロー中' : 'フォローする' }}
				</button>
			</div>
		</div> -->
	</div>
</template>
